
export const WSRoot =
  window.location.host === "play.excelmec.org"
    ? "wss://api.play.excelmec.org/"
    : "ws://34.55.110.34/";

export const ApiRoot =
  window.location.host === "play.excelmec.org"
    ? "https://kryptos-api.excelmec.org"
    : "http://34.55.110.34/";
    

export const MiniRoot = "https://leaderboard-production-a241.up.railway.app"

export const AuthRoot =
  window.location.host === "play.excelmec.org"
    ? "https://accounts-api.excelmec.org/api"
    : "https://accounts-api.excelmec.org/api";

export const AERoot = 
  window.location.host === "play.excelmec.org"
    ? "https://auth.excelmec.org/"
    : "https://auth.excelmec.org/"

 export const SpellRoot = "https://spelling-bee-five.vercel.app/api"
